export enum LocalStorageKey {
  SchemaVersion = 'luna.schemaVersion',
  ColorScheme = 'luna.contexts.colorScheme.colorScheme',
  ColorSchemeFollowsSystem = 'luna.contexts.colorScheme.followsSystem',
  UserPins = 'luna.contexts.userPins.userPins',
  AdminResourcesLayout = 'luna.screens.home.admin.resources.layout',
  DisplaysZoom = 'luna.screens.home.displays.zoom',
  DisplayInputConfig = 'luna.screens.home.display.inputConfig',
  DisplayInspectorTab = 'luna.screens.display.inspectorTab',
  DisplayInspectorActionsCollapsed = 'luna.screens.home.display.inspector.actions.isCollapsed',
  DisplayInspectorAnimatorCollapsed = 'luna.screens.home.display.inspector.animator.isCollapsed',
  DisplayInspectorApiTokenCollapsed = 'luna.screens.home.display.inspector.apiToken.isCollapsed',
  DisplayInspectorInputCollapsed = 'luna.screens.home.display.inspector.input.isCollapsed',
  DisplayInspectorOptionsCollapsed = 'luna.screens.home.display.inspector.options.isCollapsed',
  MonitorInspectorRoomCollapsed = 'luna.screens.home.admin.monitor.inspector.room.isCollapsed',
  MonitorInspectorLampsCollapsed = 'luna.screens.home.admin.monitor.inspector.lamps.isCollapsed',
  MonitorInspectorSummaryCollapsed = 'luna.screens.home.admin.monitor.inspector.summary.isCollapsed',
  MonitorInspectorWarningsCollapsed = 'luna.screens.home.admin.monitor.inspector.warnings.isCollapsed',
}
